export default "__VITE_ASSET__e9368859__"